import { z } from 'zod/v4';

import { RfqStatus } from './rfqBackendTypes';

export enum SnapshotTagType {
    Live = 'Live',
    Manual = 'Manual',
    Note = 'Note',
    RfqCreated = 'RfqCreated',
    RfqStatusChanged = 'RfqStatusChanged',
    SourcingScenarioName = 'SourcingScenarioName',
    SourcingScenarioId = 'SourcingScenarioId',
    CostedBomExported = 'CostedBomExported',
    MetadataTooLarge = 'MetadataTooLarge',
}

export type SnapshotTagDTO = z.infer<typeof SnapshotTagRuntype>;
export const SnapshotTagRuntype = z.union([
    z.object({
        type: z.literal(SnapshotTagType.Live),
    }),
    z.object({
        type: z.literal(SnapshotTagType.Manual),
    }),
    z.object({
        type: z.literal(SnapshotTagType.Note),
        value: z.string(),
    }),
    z.object({
        type: z.literal(SnapshotTagType.RfqCreated),
    }),
    z.object({
        type: z.literal(SnapshotTagType.RfqStatusChanged),
        value: z.enum(RfqStatus),
    }),
    z.object({
        type: z.literal(SnapshotTagType.SourcingScenarioName),
        value: z.string(),
    }),
    z.object({
        type: z.literal(SnapshotTagType.SourcingScenarioId),
        value: z.string(),
    }),
    z.object({
        type: z.literal(SnapshotTagType.CostedBomExported),
    }),
    z.object({
        type: z.literal(SnapshotTagType.MetadataTooLarge),
    }),
]);

export type SnapshotMetadataItemDTO = {
    id: string;
    created_at: string;
    rfq_id: string;
    tags: SnapshotTagDTO[];
};

export const SnapshotMetadataItemRuntype: z.ZodType<SnapshotMetadataItemDTO> = z.object({
    id: z.string(),
    created_at: z.string(),
    rfq_id: z.string(),
    tags: z.array(SnapshotTagRuntype),
});
